<template>
  <div class="income-investigation-onboarding">
    <progress-header
      :top-image-path="'header-green-top-square.svg'"
      :bottom-image-path="'header-green-bottom-square.svg'"
      :header-text="headerTitle"
      :color-variant="'green'"
    />
    <div class="page-content">
      <expandable-transaction-check-list v-if="hasPredictedQuestions"
                        :color-variant="'green'"
                        :title="'הכנסות קבועות'"
                        :is-expandable="false"
                        :transaction-list="hasPredictedQuestions ? predictedIncomeQuestionsList : actualIncomeQuestionsList"
                        :toggleCheck="togglePredictedIsFixed">
        <template v-slot:subtitle>
          <div class="subtitle">
            המערכת זיהתה הכנסות שחזרו על עצמן בחודשים קודמים, ולפי זה היא צופה כמה כסף ייכנס בחודשים הבאים.
            <span class="bold"> יש כאן הכנסה שלא הולכת לחזור? </span>אפשר להסיר אותה.
          </div>
        </template>
      </expandable-transaction-check-list>
      <expandable-transaction-check-list
                        :title="varibaleTransactionsTitle"
                        :is-expandable="hasPredictedQuestions"
                        :color-variant="'green'"
                        :transaction-list="actualIncomeQuestionsList"
                        :toggleCheck="toggleActualIsFixed">
        <template v-if="!hasPredictedQuestions" v-slot:subtitle>
          <div class="subtitle">
            המערכת זיהתה רק הכנסות שלא הולכות לחזור בחודשים הבאים. אולי פיספסנו ו<span class="bold">יש כאן הכנסה קבועה?</span> אם כן, אפשר לסמן אותה.
          </div>
        </template>
      </expandable-transaction-check-list>
      <div class="button-container">
        <riseup-button
          class="done-btn"
          :action="() => doneAnswering()"
          :title="'סיימתי, אפשר להמשיך'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import moneyUtils from '../../../../../../utils/money';
import consts from '../../../../../../constants/onboarding-state';
import TransactionCheckList from '../../../../../../base-components/onboarding/TransactionCheckList.vue';
import ExpandableTransactionCheckList from '../../../../../../base-components/onboarding/ExpandableTransactionCheckList.vue';
import ProgressHeader from '../../../../../../base-components/onboarding/ProgressHeader.vue';
import Segment from '../../../../../../Segment';

export default {
  name: 'IncomeInvestigationOnboarding',
  components: {
    TransactionCheckList,
    ExpandableTransactionCheckList,
    RiseupButton: BaseUI.RiseupButton,
    Separator: BaseUI.Separator,
    ProgressHeader,
  },
  async created() {
    await this.fetchIncomeQuestions();
    const numberOfFixedTransactions = this.predictedIncomeQuestions.filter(question => question.isFixed).length;
    const numberOfVariableTransactions = this.actualIncomeQuestions.length;
    Segment.trackUserGot('FixedIncomeReviewEntered', { numberOfFixedTransactions, numberOfVariableTransactions });
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapState('incomeInvestigationQuestions', ['actualIncomeQuestions', 'predictedIncomeQuestions']),
    currentPageName() {
      return consts.ONBOARDING_PAGE.INCOME_INVESTIGATION;
    },
    predictedIncomeQuestionsList() {
      return _.chain(this.predictedIncomeQuestions)
        .filter(question => question.incomeAmount > 0)
        .map(question => {
          return {
            businessName: question.businessName,
            amount: question.incomeAmount,
            isChecked: question.isFixed,
            envelopeId: question.envelopeId,
          };
        }).value();
    },
    actualIncomeQuestionsList() {
      return _.map(this.actualIncomeQuestions, question => {
        return {
          businessName: question.businessName,
          amount: question.incomeAmount,
          isChecked: question.isFixed,
          transactionId: question.transactionId,
        };
      });
    },
    hasPredictedQuestions() {
      return !_.isEmpty(this.predictedIncomeQuestions);
    },
    headerTitle() {
      return `${this.householdName}, המערכת זיהתה הכנסות`;
    },
    varibaleTransactionsTitle() {
      return this.hasPredictedQuestions ?
        'אולי פספסנו משהו?' :
        'לא זיהינו הכנסות קבועות בחשבון';
    },
  },
  methods: {
    ...mapActions('incomeInvestigationQuestions', ['fetchIncomeQuestions', 'saveIncomeInputs']),
    ...mapActions('onboardingState', ['nextPage']),
    ...mapMutations('incomeInvestigationQuestions', ['setPredictedIsFixed', 'setActualIsFixed']),
    async doneAnswering() {
      await this.saveIncomeInputs();
      const numberOfRemovedFixed = this.predictedIncomeQuestions.filter(question => !question.isFixed).length;
      const numberOfAddedVariables = this.actualIncomeQuestions.filter(question => question.isFixed).length;
      Segment.trackUserInteraction('FixedIncomeReviewNextClicked', { numberOfRemovedFixed, numberOfAddedVariables });
      await this.nextPage(this.currentPageName);
    },
    formatAmount(amount) {
      return moneyUtils.formatAmountWithFraction(amount, 0);
    },
    togglePredictedIsFixed(question) {
      const isChecked = !question.isChecked;
      this.setPredictedIsFixed({ envelopeId: question.envelopeId, isFixed: isChecked });
    },
    toggleActualIsFixed(question) {
      const isChecked = !question.isChecked;
      this.setActualIsFixed({ transactionId: question.transactionId, isFixed: isChecked });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';

  .income-investigation-onboarding {
    @include white-page-frame;
    height: 100%;

    .page-content {
      height: 100%;
      width: 100%;
      .button-container {
        @include responsive-padding;
        @include responsive-padding-top-bottom;

        .done-btn {
          width: 100%;
          white-space: nowrap;
        }
      }
    }
    .subtitle {
      font-size: 18px;
      color: $riseup_black;
      margin-bottom: 40px;
      line-height: 1.33;
      .bold {
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/steps/income-investigation/IncomeInvestigationOnboarding.vue